import { ReactNode } from 'react';

import BgNsInputter from '@britishgasenergy/react-nucleus/dist/nuc-components/NsInputter';

import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

type NsInputterProps = {
  className?: string;
  mask?: string;
  onChange?: (event: NsInputterEvent) => void;
  separator?: string;
  ignoreseparator?: boolean;
  value?: string | boolean | number;
  helper?: string;
  name?: string;
  heading?: string;
  validation?: string[];
  children?: ReactNode;
  tipDetail?: ReactNode;
};

export const NsInputter = ({
  onChange = () => {},
  children,
  className,
  mask,
  separator,
  ignoreseparator = true,
  validation = [],
  value = '',
  heading,
  helper,
  tipDetail,
  name
}: NsInputterProps) => {
  const changeHandler = (nucleusCustomEvent) => {
    const event = new NsInputterEvent(nucleusCustomEvent);

    onChange(event);
  };

  const stringValue = value === null ? '' : `${value}`;

  if (!children) {
    // Nucleus throws error if it cannot find a <label> child element
    return null;
  }

  return (
    <BgNsInputter
      className={className}
      mask={mask}
      separator={separator}
      ignoreSeparator={ignoreseparator}
      validation={validation}
      value={stringValue}
      heading={heading}
      helper={helper}
      name={name}
      onChange={changeHandler}
    >
      {tipDetail && <div slot="tip-details">{tipDetail}</div>}
      {children}
    </BgNsInputter>
  );
};
